function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00b5ee;}.b{clip-path:url(#a);}.c{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 25,
  height: 25
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "b"
}, /*#__PURE__*/React.createElement("rect", {
  className: "c",
  width: 25,
  height: 25
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M9.9,6.771V9.9H6.771V6.771H9.9m1.562-1.562H5.208v6.25h6.25V5.208ZM9.9,15.1v3.125H6.771V15.1H9.9m1.562-1.562H5.208v6.25h6.25v-6.25Zm6.771-6.771V9.9H15.1V6.771h3.125m1.563-1.562h-6.25v6.25h6.25V5.208Zm-6.25,8.333H15.1V15.1H13.542ZM15.1,15.1h1.562v1.562H15.1Zm1.562-1.562h1.563V15.1H16.667Zm-3.125,3.125H15.1v1.563H13.542ZM15.1,18.229h1.562v1.563H15.1Zm1.562-1.562h1.563v1.563H16.667ZM18.229,15.1h1.563v1.562H18.229Zm0,3.125h1.563v1.563H18.229ZM21.875,7.292h0A1.045,1.045,0,0,1,20.833,6.25V4.167H18.75a1.045,1.045,0,0,1-1.042-1.042h0A1.045,1.045,0,0,1,18.75,2.083h3.125a1.045,1.045,0,0,1,1.042,1.042V6.25A1.045,1.045,0,0,1,21.875,7.292Zm1.042,14.583V18.75a1.045,1.045,0,0,0-1.042-1.042h0a1.045,1.045,0,0,0-1.042,1.042v2.083H18.75a1.045,1.045,0,0,0-1.042,1.042h0a1.045,1.045,0,0,0,1.042,1.042h3.125A1.045,1.045,0,0,0,22.917,21.875ZM3.125,22.917H6.25a1.045,1.045,0,0,0,1.042-1.042h0A1.045,1.045,0,0,0,6.25,20.833H4.167V18.75a1.045,1.045,0,0,0-1.042-1.042h0A1.045,1.045,0,0,0,2.083,18.75v3.125A1.045,1.045,0,0,0,3.125,22.917ZM2.083,3.125V6.25A1.045,1.045,0,0,0,3.125,7.292h0A1.045,1.045,0,0,0,4.167,6.25V4.167H6.25A1.045,1.045,0,0,0,7.292,3.125h0A1.045,1.045,0,0,0,6.25,2.083H3.125A1.045,1.045,0,0,0,2.083,3.125Z"
}));

function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.7f7c847f.svg";
export { ForwardRef as ReactComponent };